// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={153}
    height={152}
    viewBox="0 0 153 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M39.0656 112.318L34.7548 40.1544C34.7411 39.9259 34.7745 39.6971 34.8528 39.482C34.9311 39.2668 35.0528 39.0699 35.2103 38.9032C35.3678 38.7365 35.5579 38.6036 35.7688 38.5126C35.9798 38.4216 36.2072 38.3745 36.4372 38.374L103.108 38.2455C103.539 38.2447 103.955 38.408 104.269 38.7022C104.583 38.9963 104.772 39.3989 104.798 39.8274L109.12 112.183L39.0656 112.318Z"
      fill="#FFD074"
    />
    <path
      d="M38.9297 112.46L38.9216 112.326L34.6109 40.1621C34.5961 39.9143 34.6323 39.6662 34.7173 39.4329C34.8023 39.1996 34.9342 38.986 35.105 38.8052C35.2758 38.6245 35.4819 38.4803 35.7107 38.3816C35.9395 38.2829 36.1861 38.2318 36.4355 38.2312L103.106 38.1029C103.574 38.1022 104.025 38.2795 104.365 38.5985C104.706 38.9174 104.911 39.3539 104.939 39.8186L109.271 112.325L109.119 112.325L38.9297 112.46ZM103.698 38.5027C103.511 38.4259 103.31 38.3867 103.107 38.3873L36.4362 38.5157C36.2257 38.5161 36.0175 38.5593 35.8244 38.6426C35.6313 38.7259 35.4574 38.8476 35.3132 39.0002C35.169 39.1528 35.0576 39.3331 34.986 39.53C34.9143 39.7269 34.8837 39.9364 34.8962 40.1455L39.1989 112.175L108.967 112.041L104.654 39.8351C104.637 39.5461 104.538 39.2677 104.369 39.0321C104.199 38.7964 103.967 38.6129 103.698 38.5027V38.5027Z"
      fill="black"
    />
    <path
      d="M37.9093 50.783L40.9994 107.556L48.2522 90.041L41.7466 50.7714L37.9093 50.783Z"
      fill="#FF9D33"
    />
    <path
      d="M43.4692 92.7537L40.9719 49.3601C40.9619 49.1853 40.9877 49.0102 41.048 48.8457C41.1082 48.6812 41.2015 48.5306 41.3221 48.4031C41.4428 48.2757 41.5884 48.1741 41.7498 48.1046C41.9113 48.035 42.0854 47.999 42.2614 47.9986L109.723 47.8686C110.054 47.8679 110.373 47.9935 110.614 48.2195C110.855 48.4455 111 48.7547 111.019 49.0836L113.524 92.6186L43.4692 92.7537Z"
      fill="#FFE9A4"
    />
    <mask
      id="mask0_1388_70940"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={40}
      y={47}
      width={74}
      height={46}
    >
      <path
        d="M43.462 92.7673L40.9792 49.3667C40.9692 49.1918 40.9951 49.0167 41.0554 48.8521C41.1156 48.6875 41.209 48.5369 41.3297 48.4094C41.4504 48.2819 41.5959 48.1803 41.7574 48.1106C41.9189 48.041 42.093 48.0049 42.2689 48.0045L109.724 47.8524C110.055 47.8517 110.374 47.9772 110.615 48.2031C110.856 48.4291 111 48.7383 111.019 49.0672L113.51 92.6093L43.462 92.7673Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1388_70940)">
      <path
        d="M41.0505 52.107L111.104 51.9456L110.793 46.3009L40.8692 46.977L41.0505 52.107Z"
        fill="#FF9D33"
      />
    </g>
    <path
      d="M45.685 90.3337L44.3818 65.3991L56.7077 65.4067L58.1381 90.3241L45.685 90.3337Z"
      fill="#FFD074"
    />
    <path
      d="M44.0881 61.4162L44.0086 59.4646L56.5189 59.3982L56.5473 61.4065L44.0881 61.4162Z"
      fill="#FFD074"
    />
    <path
      d="M52.2458 63.092L44.2803 63.0942L44.2799 63.3224L52.2454 63.3202L52.2458 63.092Z"
      fill="#FFD074"
    />
    <path
      d="M56.7389 63.0959L53.7295 63.0967L53.7291 63.3221L56.7385 63.3212L56.7389 63.0959Z"
      fill="#E0DDD5"
    />
    <path
      d="M56.63 62.1082L49.2832 62.1506L49.2841 62.3676L56.6309 62.3252L56.63 62.1082Z"
      fill="#E0DDD5"
    />
    <path
      d="M48.0606 62.1456L44.1182 62.1687L44.1191 62.3885L48.0615 62.3654L48.0606 62.1456Z"
      fill="#FFD074"
    />
    <path
      d="M60.1213 90.4934L60.1164 90.3863L58.661 59.0748L58.7783 59.0744L104.6 58.8911L106.12 90.168L106.002 90.1687L60.1213 90.4934ZM58.8962 59.2977L60.3358 90.2683L105.884 89.9456L104.386 59.116L58.8962 59.2977Z"
      fill="#E0DDD5"
    />
    <path
      d="M106.571 58.8608L109.448 58.813L111.001 90.2522L108.157 90.2208L106.571 58.8608Z"
      fill="#E0DDD5"
    />
    <path
      d="M46.6514 78.0026L46.5948 76.6137L55.4984 76.5663L55.5187 77.9957L46.6514 78.0026Z"
      fill="#FFE9A4"
    />
    <path
      d="M47.1543 88.1207L47.0887 86.5092L48.8379 86.4995L48.9292 88.1207L47.1543 88.1207ZM47.3227 86.7317L47.37 87.897L48.6917 87.8969L48.6255 86.7247L47.3227 86.7317Z"
      fill="#FFE9A4"
    />
    <path
      d="M46.931 84.9031L46.8654 83.2915L48.6523 83.2817L48.7433 84.903L46.931 84.9031ZM47.0995 83.514L47.1467 84.6794L48.5058 84.6792L48.4399 83.5069L47.0995 83.514Z"
      fill="#FFE9A4"
    />
    <path
      d="M55.6956 79.9972L49.5615 80.0327L49.5624 80.2506L55.6965 80.2151L55.6956 79.9972Z"
      fill="#FFE9A4"
    />
    <path
      d="M55.6777 80.8211L49.5996 80.8228L49.5992 81.0499L55.6773 81.0482L55.6777 80.8211Z"
      fill="#FFE9A4"
    />
    <path
      d="M55.8636 83.5499L49.7295 83.5854L49.7304 83.8033L55.8645 83.7678L55.8636 83.5499Z"
      fill="#FFE9A4"
    />
    <path
      d="M55.8537 84.3772L49.7754 84.3789L49.775 84.606L55.8533 84.6043L55.8537 84.3772Z"
      fill="#FFE9A4"
    />
    <path
      d="M56.1097 86.7872L49.9756 86.8228L49.9765 87.0407L56.1106 87.0051L56.1097 86.7872Z"
      fill="#FFE9A4"
    />
    <path
      d="M56.0966 87.6126L50.0186 87.6143L50.0182 87.8414L56.0963 87.8397L56.0966 87.6126Z"
      fill="#FFE9A4"
    />
    <path
      d="M46.6652 81.4713L46.5996 79.8599L48.4543 79.8496L48.5455 81.4715L46.6652 81.4713ZM46.8336 80.0824L46.881 81.2476L48.3081 81.2476L48.2419 80.0747L46.8336 80.0824Z"
      fill="#FFE9A4"
    />
    <path
      d="M50.7796 72.1429C49.7738 72.1377 48.9189 72.7916 48.5199 73.7383C48.5269 73.7459 48.5339 73.7535 48.541 73.7611C48.8347 74.0996 49.1965 74.3729 49.603 74.5633C50.0095 74.7538 50.4518 74.8572 50.9013 74.8669C51.3334 74.8673 51.7603 74.7701 52.1499 74.5828C52.5395 74.3955 52.8817 74.1228 53.151 73.7852C53.1578 73.7774 53.1643 73.7694 53.171 73.7615C52.6864 72.8108 51.7851 72.1482 50.7796 72.1429V72.1429ZM50.6473 69.1813C50.0569 69.1782 49.6188 69.7161 49.6484 70.379C49.678 71.0419 50.1644 71.5847 50.7548 71.5877C51.334 71.5908 51.7705 71.0528 51.7409 70.3899C51.7113 69.7271 51.2265 69.1843 50.6473 69.1813"
      fill="#FFE9A4"
    />
    <path
      d="M48.517 73.7381C47.8577 73.0066 47.4768 72.0675 47.4405 71.0836C47.3477 69.0075 48.7485 67.3254 50.5622 67.3349C52.3694 67.3443 53.9147 69.0419 54.0074 71.118C54.0686 72.0716 53.7693 73.0146 53.1686 73.7613C53.1619 73.7692 53.1553 73.7772 53.1485 73.7851C52.8792 74.1226 52.537 74.3953 52.1473 74.5827C51.7577 74.77 51.3308 74.8671 50.8986 74.8668C50.4491 74.8571 50.0068 74.7537 49.6002 74.5632C49.1937 74.3727 48.8319 74.0995 48.5381 73.761C48.531 73.7534 48.524 73.7457 48.517 73.7381V73.7381ZM50.553 67.1287C48.6388 67.1187 47.1625 68.8914 47.2604 71.0827C47.2993 72.1314 47.7088 73.1317 48.4165 73.907C48.7271 74.2635 49.1091 74.5514 49.538 74.7521C49.967 74.9529 50.4336 75.0622 50.9078 75.0729C51.3639 75.0731 51.8145 74.9707 52.2258 74.7732C52.6371 74.5757 52.9986 74.2883 53.2833 73.9324C53.9304 73.1412 54.2535 72.1359 54.1875 71.1189C54.0896 68.9276 52.4591 67.1387 50.553 67.1287"
      fill="#FFE9A4"
    />
    <path
      d="M102.642 63.2223C102.783 63.2816 102.905 63.3785 102.994 63.5024C103.083 63.6263 103.136 63.7724 103.147 63.9244L103.299 66.0278C103.307 66.1324 103.294 66.2378 103.261 66.3376C103.228 66.4374 103.175 66.5295 103.105 66.6085C103.04 66.6827 102.961 66.743 102.871 66.7859C102.782 66.8288 102.685 66.8533 102.587 66.8582C102.474 66.8641 102.361 66.8448 102.257 66.8018C102.116 66.7426 101.994 66.6456 101.905 66.5217C101.816 66.3978 101.763 66.2517 101.752 66.0996L101.601 63.9963C101.592 63.8916 101.605 63.7863 101.638 63.6865C101.671 63.5867 101.724 63.4946 101.794 63.4156C101.859 63.3414 101.939 63.2811 102.028 63.2382C102.117 63.1953 102.214 63.1708 102.312 63.1659C102.425 63.16 102.538 63.1793 102.642 63.2223V63.2223ZM102.709 63.0607C102.561 62.9993 102.399 62.9774 102.239 62.9971C102.079 63.0168 101.928 63.0774 101.798 63.1729C101.669 63.2685 101.567 63.3957 101.501 63.5423C101.436 63.6889 101.41 63.8497 101.426 64.0092L101.577 66.1125C101.59 66.297 101.654 66.4743 101.763 66.6245C101.871 66.7748 102.019 66.8921 102.19 66.9634C102.338 67.0248 102.5 67.0466 102.66 67.027C102.82 67.0073 102.972 66.9467 103.101 66.8511C103.23 66.7556 103.333 66.6283 103.398 66.4818C103.463 66.3352 103.489 66.1743 103.474 66.0149L103.322 63.9116C103.309 63.7271 103.245 63.5498 103.137 63.3996C103.028 63.2493 102.881 63.132 102.709 63.0607V63.0607Z"
      fill="#E0DDD5"
    />
    <path
      d="M102.112 60.3552C101.987 60.3628 101.864 60.3954 101.752 60.4511C101.639 60.5068 101.539 60.5844 101.457 60.6793C101.375 60.7743 101.313 60.8846 101.275 61.0038C101.236 61.123 101.222 61.2486 101.234 61.3731C101.25 61.6284 101.365 61.8673 101.555 62.039C101.745 62.2108 101.995 62.302 102.252 62.2934C102.377 62.2858 102.5 62.2531 102.612 62.1975C102.725 62.1418 102.825 62.0642 102.907 61.9692C102.989 61.8743 103.051 61.764 103.089 61.6448C103.128 61.5256 103.142 61.4001 103.13 61.2755C103.114 61.0202 102.999 60.7813 102.809 60.6095C102.619 60.4378 102.369 60.3465 102.112 60.3552V60.3552ZM102.756 61.4263L102.296 61.45L102.33 61.9186L102.121 61.9293L102.087 61.4607L101.627 61.4844L101.612 61.2695L102.071 61.2458L102.038 60.7772L102.247 60.7664L102.281 61.2351L102.74 61.2114L102.756 61.4263Z"
      fill="#E0DDD5"
    />
    <path
      d="M107.872 63.0737C108.237 63.2233 108.656 63.0493 108.807 62.685C108.958 62.3207 108.784 61.9041 108.418 61.7545C108.053 61.6049 107.635 61.779 107.484 62.1433C107.333 62.5076 107.507 62.9241 107.872 63.0737Z"
      fill="#FFE9A4"
    />
    <path
      d="M108.831 60.6859L107.398 60.7124L107.402 60.8945L108.834 60.868L108.831 60.6859Z"
      fill="#FFE9A4"
    />
    <path
      d="M107.392 60.3797L107.389 60.1959L108.821 60.1683L108.824 60.3521L107.392 60.3797Z"
      fill="#FFE9A4"
    />
    <path
      d="M108.811 59.653L107.379 59.6794L107.382 59.8615L108.814 59.835L108.811 59.653Z"
      fill="#FFE9A4"
    />
    <path
      d="M43.3351 92.8964L43.3273 92.762L40.8299 49.3684C40.8187 49.1742 40.8475 48.9799 40.9144 48.7972C40.9812 48.6145 41.0848 48.4473 41.2188 48.3058C41.3528 48.1643 41.5144 48.0515 41.6937 47.9743C41.873 47.897 42.0663 47.857 42.2617 47.8566L109.724 47.7265C110.091 47.7259 110.445 47.8654 110.712 48.1164C110.98 48.3673 111.141 48.7105 111.162 49.0756L113.676 92.7608L113.525 92.7611L43.3351 92.8964ZM110.165 48.0969C110.025 48.0396 109.875 48.0104 109.724 48.0109L42.2624 48.141C42.1058 48.1413 41.951 48.1734 41.8073 48.2353C41.6636 48.2971 41.5342 48.3875 41.4268 48.5009C41.3194 48.6142 41.2364 48.7482 41.1828 48.8945C41.1292 49.0409 41.1062 49.1966 41.1151 49.3522L43.6047 92.6115L113.373 92.4769L110.877 49.0918C110.864 48.8761 110.791 48.6683 110.665 48.4922C110.539 48.3162 110.365 48.1791 110.165 48.0969V48.0969Z"
      fill="#29292F"
    />
    <path
      d="M43.5842 50.6814C43.8754 50.5232 43.9532 50.1064 43.7578 49.7505C43.5625 49.3946 43.1681 49.2343 42.8769 49.3925C42.5857 49.5507 42.5079 49.9675 42.7033 50.3234C42.8986 50.6794 43.293 50.8397 43.5842 50.6814Z"
      fill="#FFE9A4"
    />
    <path
      d="M45.2604 49.6807C45.2992 49.6969 45.336 49.7175 45.37 49.7423C45.485 49.8252 45.5694 49.9435 45.61 50.0789C45.6507 50.2144 45.6454 50.3593 45.5949 50.4914C45.5761 50.5318 45.5494 50.5681 45.5163 50.5981C45.4832 50.6281 45.4444 50.6512 45.4022 50.6661C45.36 50.6809 45.3152 50.6872 45.2705 50.6845C45.2258 50.6819 45.1821 50.6703 45.1419 50.6506C45.1031 50.6344 45.0663 50.6138 45.0323 50.589C44.9173 50.5061 44.833 50.3878 44.7923 50.2523C44.7517 50.1169 44.7571 49.9719 44.8076 49.8399C44.8264 49.7994 44.8531 49.7631 44.8862 49.7331C44.9192 49.7031 44.958 49.68 45.0002 49.6652C45.0424 49.6504 45.0872 49.6441 45.1319 49.6468C45.1766 49.6494 45.2203 49.661 45.2604 49.6807V49.6807ZM45.3331 49.505C45.2706 49.476 45.2031 49.4594 45.1342 49.4563C45.0654 49.4532 44.9966 49.4637 44.9318 49.4871C44.8671 49.5105 44.8076 49.5464 44.7568 49.5927C44.706 49.6391 44.6648 49.6949 44.6357 49.7571C44.5653 49.9293 44.555 50.1201 44.6066 50.2988C44.6582 50.4776 44.7687 50.6339 44.9202 50.7428C44.9664 50.7764 45.0165 50.8044 45.0693 50.8262C45.1317 50.8553 45.1993 50.8719 45.2681 50.875C45.337 50.878 45.4058 50.8676 45.4705 50.8442C45.5353 50.8208 45.5948 50.7849 45.6456 50.7386C45.6964 50.6923 45.7376 50.6364 45.7667 50.5743C45.8371 50.402 45.8474 50.2112 45.7958 50.0324C45.7442 49.8537 45.6337 49.6973 45.4821 49.5885C45.4359 49.5549 45.3859 49.5269 45.3331 49.505V49.505Z"
      fill="#FFE9A4"
    />
    <path
      d="M85.4519 63.0687L87.4676 58.1952C87.5323 58.0377 87.5568 57.8666 87.5391 57.6973C87.5213 57.5279 87.4618 57.3656 87.3658 57.2246C87.2698 57.0837 87.1403 56.9685 86.9889 56.8893C86.8374 56.8102 86.6686 56.7694 86.4976 56.7708L63.4652 56.9165C63.0247 56.9188 62.5947 57.0506 62.2293 57.2953C61.8639 57.54 61.5793 57.8867 61.4113 58.2919L39.0661 112.317L109.328 112.267L129.051 64.581C129.113 64.431 129.136 64.2681 129.12 64.1068C129.103 63.9455 129.047 63.7906 128.956 63.6559C128.866 63.5213 128.743 63.4108 128.599 63.3344C128.456 63.2579 128.295 63.2178 128.132 63.2175L85.4519 63.0687Z"
      fill="#FFD074"
    />
    <path
      d="M38.8514 112.46L61.2779 58.2378C61.456 57.8063 61.7586 57.437 62.1475 57.1765C62.5364 56.916 62.9941 56.7761 63.4629 56.7743L86.4953 56.6285C86.6899 56.627 86.8819 56.6734 87.0542 56.7635C87.2265 56.8537 87.3738 56.9848 87.4829 57.1451C87.5921 57.3055 87.6597 57.4903 87.6799 57.6829C87.7 57.8756 87.6721 58.0702 87.5984 58.2494L85.6636 62.9273L128.132 63.0753C128.318 63.0757 128.501 63.1217 128.666 63.2092C128.83 63.2967 128.97 63.423 129.074 63.5771C129.178 63.7312 129.242 63.9083 129.261 64.0928C129.279 64.2773 129.252 64.4636 129.182 64.6352L109.422 112.409L109.327 112.409L38.8514 112.46ZM86.8457 56.9803C86.7352 56.9351 86.6168 56.9122 86.4973 56.913L63.4649 57.0588C63.0524 57.0602 62.6496 57.1833 62.3073 57.4124C61.9651 57.6415 61.6988 57.9663 61.542 58.346L39.278 112.175L109.231 112.125L128.918 64.527C128.97 64.3984 128.99 64.2589 128.976 64.1208C128.962 63.9827 128.914 63.8502 128.836 63.7349C128.758 63.6196 128.653 63.525 128.53 63.4596C128.407 63.3941 128.27 63.3598 128.131 63.3595L85.2376 63.2101L87.3342 58.1411C87.3912 58.0061 87.4132 57.859 87.3982 57.7133C87.3831 57.5676 87.3315 57.4279 87.2481 57.3072C87.1493 57.1611 87.0093 57.0474 86.8457 56.9803V56.9803Z"
      fill="black"
    />
    <path
      d="M68.0515 93.0549L97.8583 93.0187L101.905 83.2359L72.0662 83.3484L68.0515 93.0549Z"
      fill="#FF9D33"
    />
  </svg>
);
const SvgFolder = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgFolder;
